import { supabase } from './supabase.js';

const PURCHASE_ERRORS = {
  not_authenticated: 'Inicia sesión para comprar.',
  listing_not_found: 'Este anuncio ya no está disponible.',
  listing_is_auction: 'Este artículo es una subasta; usa el flujo de puja.',
  listing_not_available: 'Este anuncio no está disponible para compra.',
  cannot_buy_own_listing: 'No puedes comprar tu propio anuncio.',
  listing_already_in_sale: 'Ya hay una compra en curso para este anuncio.',
};

function mapRpcError(error, fallback) {
  const msg = String(error?.message || '');
  for (const [code, text] of Object.entries(PURCHASE_ERRORS)) {
    if (msg.includes(code)) return text;
  }
  return fallback || msg || 'No se pudo completar la operación.';
}

/**
 * @deprecated Usar `startListingCheckout` en marketplaceStripeService.js (Stripe Checkout).
 * El RPC ya no está concedido a usuarios autenticados; solo fulfill servidor tras pago.
 */
export async function createMarketplacePurchase({ listingId, shippingOption = 3 }) {
  const { data, error } = await supabase.rpc('create_marketplace_purchase', {
    p_listing_id: listingId,
    p_shipping_option: shippingOption,
  });
  if (error) {
    console.error('[transactionsService] createMarketplacePurchase:', error);
    return { transactionId: null, error: mapRpcError(error, 'No se pudo registrar la compra.') };
  }
  return { transactionId: data, error: null };
}

export async function sellerMarkTransactionShipped(transactionId, trackingNumber) {
  const { error } = await supabase.rpc('seller_mark_transaction_shipped', {
    p_transaction_id: transactionId,
    p_tracking_number: trackingNumber || null,
  });
  if (error) {
    console.error('[transactionsService] sellerMarkTransactionShipped:', error);
    return { error: error.message || 'No se pudo marcar como enviado.' };
  }
  return { error: null };
}

export async function sellerSetTransactionToPartnerMode(transactionId, mode) {
  const { error } = await supabase.rpc('seller_set_transaction_to_partner_mode', {
    p_transaction_id: transactionId,
    p_mode: mode,
  });
  if (error) {
    console.error('[transactionsService] sellerSetTransactionToPartnerMode:', error);
    return { error: error.message || 'No se pudo guardar la forma de entrega.' };
  }
  return { error: null };
}

export async function buyerConfirmTransactionReceipt(transactionId) {
  const { error } = await supabase.rpc('buyer_confirm_transaction_receipt', {
    p_transaction_id: transactionId,
  });
  if (error) {
    console.error('[transactionsService] buyerConfirmTransactionReceipt:', error);
    return { error: error.message || 'No se pudo confirmar la recepción.' };
  }
  return { error: null };
}
